import { action, computed, makeObservable, observable } from 'mobx';

export default class InvoicePriceStore {
  @observable
  public showPriceWithVat = true;

  public constructor() {
    makeObservable(this);
  }

  @action
  public toggleShowPriceWithVat(checked: boolean): void {
    this.showPriceWithVat = checked;
  }

  @computed
  public get showPriceWithoutVat(): boolean {
    return !this.showPriceWithVat;
  }
}
